var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.listGroupFragment},[(_vm.label)?_c('h2',[_vm._v(_vm._s(_vm.label))]):_vm._e(),(_vm.hasDescriptionSlotContent)?_c('p',{class:_vm.$style.descriptionSmall},[_vm._t("description")],2):_vm._e(),_c('ul',{class:_vm.$style.listGroup},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }